import React from 'react';
import { Box, styled } from '@mui/material';

export const HBox = styled(
  Box,
  {
    name: 'HBox',
    slot: 'root'
  }
)(({ theme }) => ({
   display: 'flex',
   flexDirection: 'row',
   alignItems: 'center',
   gap: '10pt'
}))
